import React from 'react'
import { useSelector } from 'react-redux'
import { ServiciosItem } from './ServiciosItem'
import { serviciosClienteReduce } from './serviciosClienteReduce'

export const Servicios = ({ cliente }) => {
    const { asistenciasMes } = useSelector(state => state.reportesReducer)
    const listado = serviciosClienteReduce(asistenciasMes, cliente.Id)

    return (
        <div style={{  padding: 5, borderBottom: '1px solid #ccc' }}>
            {listado.map((reg, i) => <ServiciosItem reg={reg} key={i} />)}
        </div>
    )
}
